var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 139.86 58.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2830",
    className: "cls-1",
    d: "M29.23,0c-.7,0-1.41.02-2.12.07C11.08,1.17-1.03,15.06.07,31.09c1.1,16.03,14.99,28.14,31.02,27.04,9.44-.65,17.98-5.85,22.89-13.94h24.67l5.16,12.6h10.82l5.16-12.6h24.54l5.24,12.6h10.29L116.61.87h-9.38l-18,44.06L71.2.86h-9.37l-14.83,35.37c-4.87,11.63-18.14,15.35-27.67,9.84-9.37-5.41-12.59-17.39-7.18-26.77,5.41-9.37,17.38-12.58,26.76-7.18.61.36,1.2.75,1.77,1.17l4.09-8.74c-.36-.23-.73-.44-1.1-.65C39.28,1.35,34.3,0,29.23,0ZM66.48,14.46l8.27,20.23h-16.68l8.41-20.23ZM111.96,14.46l8.41,20.23h-16.68l8.27-20.23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaa);
export default __webpack_public_path__ + "static/media/caa.b35bca5bbe59b2c198cbd9518abc93f4.svg";
export { ForwardRef as ReactComponent };